import { Box, Button, Link, Stack, Text } from "@chakra-ui/react";
import { AlertCircle } from "lucide-react";

const homeHost = process.env.NEXT_PUBLIC_HOME_HOST;

type ErrorScreenProps = {
  message: string;
  showHomeLink?: boolean;
  onSelectWorkspace?: () => void;
  // NOTE: セッションは残っているが復帰できない状態から抜け出すための導線。
  //       ID セッションを破棄する（他アプリを含めてサインアウトされる）ため、
  //       渡されたときのみ表示する
  onReauthenticate?: () => void;
  // NOTE: 画面固有の遷移先（例: 特定 workspace のホーム）へのリンク
  link?: { label: string; href: string };
};

export const ErrorScreen = ({
  message,
  showHomeLink,
  onSelectWorkspace,
  onReauthenticate,
  link,
}: ErrorScreenProps) => {
  const hasHomeLink = showHomeLink === true && homeHost != null;
  const hasActions =
    onSelectWorkspace != null ||
    onReauthenticate != null ||
    link != null ||
    hasHomeLink;

  return (
    <Stack alignItems="center" justify="center" gap={12} minH="dvh">
      <Stack gap={4} alignItems="center">
        <Box color="semantic.contents.tertiary">
          <AlertCircle size={48} />
        </Box>
        <Text textStyle="Paragraph/Large" color="semantic.contents.tertiary">
          {message}
        </Text>
      </Stack>
      {hasActions && (
        <Stack gap={4} alignItems="center">
          {onSelectWorkspace != null && (
            <Button variant="outline" onClick={() => onSelectWorkspace()}>
              別のワークスペースを選ぶ
            </Button>
          )}
          {onReauthenticate != null && (
            <Button variant="outline" onClick={() => onReauthenticate()}>
              ログアウトして再ログイン
            </Button>
          )}
          {link != null && (
            <Button asChild variant="outline">
              <a href={link.href}>{link.label}</a>
            </Button>
          )}
          {hasHomeLink && (
            <Link href={homeHost} color="semantic.contents.tertiary">
              Speria ホームに戻る
            </Link>
          )}
        </Stack>
      )}
    </Stack>
  );
};
